export default {
  app: {
    title: 'Clips',
    description: 'Clips courts pour les réseaux sociaux',
  },
  title: 'Clips',
  header: {
    title: 'Vos',
    titleAccent: 'clips',
    subtitle: 'Aucun projet | 1 projet de clip | {total} projets de clips',
    hint: 'Transformez vos vidéos en clips courts prêts pour TikTok, Reels et Shorts.',
    newClip: 'Nouveau clip',
  },
  empty: {
    title: 'Créez votre premier clip',
    description:
      "Choisissez une vidéo de votre bibliothèque : l'analyse repère ses moments forts et prépare un premier montage, prêt à retoucher et à exporter pour TikTok, Reels ou Shorts.",
    goToLibrary: 'Ouvrir ma bibliothèque',
  },
  create: {
    title: 'Créer un',
    titleAccent: 'clip',
    pickVideo: 'Choisir une vidéo',
    sourceLabel: 'Vidéo source',
    changeSource: 'Changer',
    description: 'Un brouillon est préparé automatiquement à partir des moments forts de la vidéo.',
    titleLabel: 'Titre du clip',
    formatLabel: 'Format',
    durationLabel: 'Durée visée',
    durations: {
      '30s': '30 sec',
      '1min': '1 min',
      '2min': '2 min',
    },
    accountOnly: 'Compte',
    durationHint:
      "Le brouillon est monté pour tenir dans cette durée. Vous pourrez ensuite ajouter ou retirer des séquences dans l'éditeur.",
    analysisNote:
      "L'analyse s'appuie sur la transcription : hooks, propos complets, pics d'audience. Vous pourrez ajuster chaque scène dans l'éditeur.",
    cancel: 'Annuler',
    confirm: 'Créer le clip',
    created: 'Clip créé — analyse en cours',
    error: 'Impossible de créer le clip',
    action: 'Créer un clip',
  },
  status: {
    analyzing: 'Analyse…',
    ready: 'Brouillon',
    exporting: 'Export…',
    exported: 'Exporté',
    failed: 'Erreur',
  },
  list: {
    filterLabel: 'Filtrer par état',
    filterAll: 'Tous',
    filterEmpty: 'Aucun clip dans cet état.',
    scenes: 'Aucune scène | 1 scène | {count} scènes',
    openEditor: "Ouvrir l'éditeur",
    deleteProject: 'Supprimer',
    deleteConfirm: {
      title: 'Supprimer le clip',
      message: 'Ce projet de clip et toutes ses scènes seront définitivement supprimés.',
      confirm: 'Supprimer le clip',
    },
    deleted: 'Projet supprimé',
    deleteError: 'La suppression du clip a échoué',
    loading: 'Chargement des projets de clips',
    loadError: "Les projets de clips n'ont pas pu être chargés.",
    retry: 'Réessayer',
  },
  editor: {
    back: 'Clips',
    source: 'Depuis « {name} »',
    rename: 'Renommer le clip',
    mobile: {
      scenes: 'Scènes',
      settings: 'Réglages',
    },
    preview: 'Aperçu',
    more: "Plus d'actions",
    formatLabel: 'Format',
    export: 'Exporter',
    exportProgress: 'Export {progress}%',
    exportStarted: 'Export lancé — vous recevrez un e-mail et une notification dès que votre clip sera prêt.',
    exportDock: {
      toastProgress: '« {name} » — export {progress}%',
      toastReady: '« {name} » est prêt 🎬',
      toastDownload: 'Télécharger',
      toastFailed: "L'export de « {name} » a échoué",
      errorNetwork: "Connexion perdue pendant le suivi de l'export",
      errorGeneric: "L'export a échoué",
    },
    exportError: "L'export a échoué",
    exportUnsaved: "Vos dernières modifications n'ont pas pu être enregistrées : corrigez-les avant d'exporter.",
    unsavedOnLeave: "Vos dernières modifications du clip n'ont pas été enregistrées.",
    exportModal: {
      title: 'Clip exporté 🎬',
      download: 'Télécharger en local',
      downloadHint: 'Fichier MP4 sur votre appareil',
      save: 'Enregistrer dans la médiathèque',
      saveHint: 'Nouvelle vidéo dans votre bibliothèque',
      saved: 'Ajouté à la médiathèque',
      open: 'Ouvrir la vidéo',
      savedToast: 'Clip ajouté à la médiathèque',
      saveError: "Impossible d'enregistrer le clip dans la médiathèque",
      reExport: 'Ré-exporter',
      reExportHint: "L'export ne contient pas les modifications faites après son lancement.",
      history: 'Exports précédents',
      historyError: "Impossible de télécharger cet export",
    },
    sourceChanged: {
      text: "La vidéo d'origine a changé depuis ce découpage : vos scènes ne tombent peut-être plus au bon endroit. Vérifiez-les, puis gardez ce découpage, ou relancez l'analyse, qui remplacera vos scènes et transcrira de nouveau la vidéo si besoin.",
      pastEnd: 'La scène {scenes} dépasse la fin de la nouvelle version : raccourcissez-la pour garder ce découpage. | Les scènes {scenes} dépassent la fin de la nouvelle version : raccourcissez-les pour garder ce découpage.',
      keep: 'Garder ce découpage',
      keepError: "Le découpage n'a pas pu être gardé",
      reanalyze: "Relancer l'analyse",
      exportBlocked: "La vidéo d'origine a changé : choisissez d'abord quoi faire de ce découpage.",
    },
    viewExport: "Voir l'export",
    analyzing: {
      title: 'Analyse de la vidéo en cours…',
      description:
        'On repère les moments forts à partir de la transcription. Cette page se mettra à jour automatiquement.',
      stepCount: 'Étape {current} / {total}',
      background: "Vous pouvez quitter cette page : l'analyse continue en arrière-plan, et un e-mail vous préviendra quand elle sera terminée.",
      remaining: {
        underMinute: "Encore moins d'une minute",
        about: 'Encore environ {minutes} min',
        range: 'Encore {low} à {high} min environ',
        hours: 'Encore {low} à {high} environ',
        queue: "Hors temps d'attente si beaucoup de vidéos sont en cours de traitement",
      },
      steps: {
        transcribing: 'Transcription de la vidéo',
        scoring: 'Repérage des moments forts',
        ranking: 'Classement des meilleurs extraits',
        assembling: 'Montage du brouillon',
        framing: 'Cadrage automatique',
      },
      hints: {
        transcribing: 'Les paroles deviennent du texte horodaté, mot par mot',
        scoring: 'Accroches, propos complets, rythme de parole',
        ranking: "Notation par l'IA et pics d'audience réels",
        assembling: 'Les scènes sont assemblées dans la durée choisie',
        framing: 'Le visage détecté est suivi dans chaque scène',
      },
    },
    analysisError: {
      title: "L'analyse a échoué",
      retry: 'Réessayer',
      retryError: "L'analyse n'a pas pu être relancée",
      reasons: {
        transcription_failed: "La transcription de la vidéo n'a pas abouti. Réessayez : une nouvelle transcription sera lancée.",
        transcript_empty: "La transcription ne contient aucune parole : il n'y a rien à découper dans cette vidéo.",
        no_moment_fits: 'Aucun passage de la vidéo ne correspond à la durée choisie. Essayez une durée plus courte.',
        queue_full: "Trop de traitements sont en attente pour votre organisation. Réessayez dans quelques minutes.",
        interrupted: "L'analyse a été interrompue. Réessayez pour la relancer.",
        analysis_failed: "L'analyse n'a pas pu aboutir. Réessayez, et contactez le support si l'erreur se reproduit.",
      },
    },
    saveStatus: {
      saved: 'Enregistré',
      saving: 'Enregistrement…',
      unsaved: 'Modifications non enregistrées',
      error: "Erreur d'enregistrement",
    },
    formats: {
      '9:16': '9:16',
      '4:5': '4:5',
      '1:1': '1:1',
    },
    scenes: {
      title: 'Scènes du clip',
      count: '{count} · {duration}',
      targetHint: 'Durée visée à la création : {duration}',
      addScene: 'Ajouter une scène',
      delete: 'Supprimer',
      start: 'Début',
      end: 'Fin',
      startAria: 'Début de la scène (m:ss)',
      endAria: 'Fin de la scène (m:ss)',
      nudgeBack: "Reculer d'une seconde",
      nudgeForward: "Avancer d'une seconde",
      transcriptLabel: 'Transcription de la scène',
      transcriptPlaceholder: 'Transcription de la scène (modifiable)…',
      cleanFillers: 'Nettoyer les « euh »',
      cleaned: 'Aucun « euh »',
      fillerCount: '1 euh | {count} euh',
      maximum: 'Un clip dure au plus 15 minutes : raccourcissez vos scènes pour enregistrer.',
      cannotDeleteLast: 'Un clip doit garder au moins une scène',
      reorderError: 'Impossible de réordonner les scènes',
    },
    focus: {
      auto: 'Automatique',
      autoHint: 'Cadre sur le visage détecté',
      autoShort: 'Auto',
      center: 'Centré',
      centerHint: "Cadre fixe au centre de l'image",
      manual: 'Manuel',
      manualHint: 'Glissez le cadre sur la vidéo',
      cropLabel: {
        auto: '✦ Suivi auto',
        center: 'Centré',
        manual: '✋ Manuel',
      },
    },
    canvas: {
      noPreview: 'Aperçu de la source à venir — le cadre reste réglable',
    },
    phone: {
      preview: 'Aperçu',
      play: 'Lire la scène',
      pause: 'Mettre en pause',
    },
    inspector: {
      crop: 'Recadrage',
      subtitles: 'Sous-titres',
      branding: 'Habillage',
      focusOfScene: 'Focus de la scène {number}',
      zoom: 'Zoom',
      removeSilences: 'Couper les silences',
      removeSilencesHint: 'Supprime les longues pauses entre les mots',
      removeSilencesSaved: '−{duration} de pauses supprimées',
      showCaptions: 'Afficher les sous-titres',
      showCaptionsHint: 'Incrustés dans la vidéo exportée',
      captionsOffWarning:
        '80 % des vidéos sur les réseaux sociaux sont regardées sans le son — les sous-titres sont fortement recommandés.',
      captionStyle: 'Style de sous-titres',
      keywordColor: 'Couleur des mots-clés',
      keywordColorHint: "S'applique aux mots-clés surlignés des sous-titres.",
      position: 'Position',
      positions: { top: 'Haut', mid: 'Milieu', bot: 'Bas' },
      textSize: 'Taille du texte',
      options: 'Options',
      keywordsColored: 'Mots-clés en couleur',
      keywordsColoredHint: 'Détectés automatiquement',
      hookText: "Accroche à l'écran",
      showHook: "Afficher l'accroche",
      showHookHint: 'En haut du clip',
      hookStyle: "Style de l'accroche",
      hookPosition: "Position de l'accroche à l'écran",
      hookStyles: {
        bar: 'Bandeau',
        bubble: 'Bulle',
        outline: 'Contour',
        minimal: 'Minimal',
      },
      logo: 'Logo',
      showLogo: 'Filigrane logo',
      showLogoHint: 'Coin supérieur droit',
      logoUpload: 'Votre logo',
      logoUploadHint: 'PNG transparent recommandé',
      progressBar: 'Barre de progression',
      showProgressBar: 'Afficher la barre',
      showProgressBarHint: 'En haut du clip',
      progressColor: 'Couleur de la barre',
      progressPosition: 'Position de la barre',
      presets: {
        karaoke: 'Karaoké',
        punch: 'Punch',
        minimal: 'Minimal',
        neon: 'Néon',
      },
    },
    timeline: {
      scene: 'Scène {number}',
      play: 'Lire le clip',
      pause: 'Mettre en pause',
      scrub: 'Position dans le clip',
    },
    previewModal: {
      close: "Fermer l'aperçu",
    },
    addScene: {
      title: 'Ajouter une',
      titleAccent: 'scène',
      description: 'Choisissez un moment fort encore inutilisé, ou définissez un passage manuellement.',
      suggested: 'Moments suggérés',
      manual: 'Sélection manuelle',
      noSuggestions: 'Toutes les suggestions ont été utilisées — passez en sélection manuelle.',
      startLabel: 'Début',
      endLabel: 'Fin',
      rangeAria: 'Sélection du passage — glissez la fenêtre ou ses poignées',
      initialFocus: 'Focus initial de la scène',
      cancel: 'Annuler',
      confirm: 'Ajouter la scène',
      added: 'Scène ajoutée',
      invalidRange: 'La fin doit être après le début',
      tooLong: 'Cette scène ferait dépasser les 15 minutes que peut durer un clip.',
      tooMany: 'Un clip compte au plus 15 scènes : retirez-en une pour en ajouter une autre.',
    },
    scoreReasons: {
      question: 'Question',
      notable_number: 'Chiffre marquant',
      strong_hook: 'Hook fort',
      complete_statement: 'Propos complet',
      good_length: 'Bonne durée',
      good_pace: 'Bon rythme',
      audience_peak: "Pic d'audience",
    },
  },
}
